const playVideoYoutube = () => {
  $('.js-play-yt').on('click', function(e) {
    e.preventDefault();
    const youtubeUrl = $(this).data('yt-url');

    $(this).html(`<iframe allowfullscreen frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen src="${youtubeUrl}"></iframe>`);
  });
}

export default playVideoYoutube;
